declare global {
  interface Window {
    Capacitor?: {
      isNativePlatform?: () => boolean;
    };
  }
}

export function isNativePlatform(): boolean {
  return typeof window !== "undefined" && !!window.Capacitor?.isNativePlatform?.();
}
